
export const decorateEnv = (env) => {
    env.build.buildDate = '20260225033050';
    env.build.buildDateEpoch = 1771990250545;
    env.build.buildRevision = '5841ebe418e3f6a9f23b7cfe05e336d92dfd2a4b';
    env.build.project = 'abbottcrdx';
    env.build.part = 'rep';
    env.build.deployment = 'uat';
    env.build.viewport = 'wow';
    env.apiRoot = 'https://crdx-sfe-api-s.abbott.com.cn';
    env.production = 'false';
    env.variables.corpId = 'wx7dbaf21fd68d3c7a';
    env.variables.mapApiKey = 'ee95e52bf08006f63fd29bcfbcf21df0';
};
